import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconZoomMoney.c.svg?react';

export const IconZoomMoney = withIconWrapper(ReactComponent);
